/* Component Dependencies */
var pointSaversLinkTemplate = require('templates/pointSaversLink.hbs');
var SendToLinkComponent = require('libs/send-to-link');

SendToLinkComponent.create({
    type: 'pointSaversLink',

    template: {
        'pointSaversLink': pointSaversLinkTemplate
    },

    events: {
        'click .js-sent-to-link': 'sendToLink'
    }
});
